import { render, staticRenderFns } from "./ProjectNavbar.vue?vue&type=template&id=01dfd2ed&"
import script from "./ProjectNavbar.vue?vue&type=script&lang=js&"
export * from "./ProjectNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports